import { useState } from "react";

import { Modal, Button, Typography } from "@king-ict/eupisi-ui/components";
import { hrDate, hrDateWithTime } from "@king-ict/eupisi-ui/utils";
import { useTranslation } from "react-i18next";

import styles from "./StatusHistoryActionButtonModal.module.scss";
import { StatusHistory } from "../../../models/Request/Request";

interface IProps {
  statusHistory: StatusHistory[] | null;
  className?: string;
}

export const StatusHistoryActionButtonModal = ({
  statusHistory,
  className,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  if (!statusHistory?.length) {
    return null;
  }

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  return (
    <>
      <Button onClick={handleOpen} size="sm" className={className}>
        {t("request.statusHistory")}
      </Button>

      <Modal
        type="message"
        title={t("request.statusHistory")}
        open={isOpen}
        onClose={handleClose}
        onConfirm={handleClose}
        confirmText={t("common.close")}
        variant="medium"
      >
        {statusHistory.map((item) => (
          <div key={item.id} className={styles.historyItem}>
            <Typography variant="mediumBold" className={styles.header}>
              {t("request.returnToProcessingNote")} -{" "}
              {hrDateWithTime(new Date(item.dateCreated))}
            </Typography>
            <div className={styles.noteContainer}>
              <Typography className={styles.noteText}>{item.note}</Typography>
            </div>
          </div>
        ))}
      </Modal>
    </>
  );
};
